<div class="sidenav">
    <div class="title">
      <div class="circle">
        <mat-icon fontIcon="luggage"></mat-icon>
      </div>
      <div class="title-text">Tourist</div>
      <div class="subtitle">Simplify Your Tourist Tax</div>
    </div>
    <mat-nav-list class="menu-list">
      <button mat-button matBadgeColor="warn"
        [routerLink]="['/app/payments']" routerLinkActive="active">
        <mat-icon fontIcon="paid"></mat-icon>Payments</button>

      <button mat-button [routerLink]="['/app/properties']" routerLinkActive="active">
        <mat-icon fontIcon="domain_add"></mat-icon>Properties</button>

        <button mat-button [routerLink]="['/app/messages']" routerLinkActive="active">
          <mat-icon fontIcon="mail" [matBadge]="unread.count()" [matBadgeHidden]="unread.count() === 0"
                    matBadgeColor="warn" matBadgeSize="small" aria-hidden="false"
                    [attr.aria-label]="unread.count() + ' unread messages'"></mat-icon>Messages</button>
        <button routerLinkActive="active" [routerLink]="['/app/profile']" mat-button><mat-icon fontIcon="account_circle"></mat-icon>Profile</button>
    </mat-nav-list>
  </div>